import React, { useEffect, useState } from "react";
import { Menu, X } from "lucide-react";
import { brand, navLinks } from "../mock";
import IntakeModal from "./IntakeModal";

const Navbar = () => {
  const [scrolled, setScrolled] = useState(false);
  const [open, setOpen] = useState(false);
  const [intakeOpen, setIntakeOpen] = useState(false);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 24);
    window.addEventListener("scroll", onScroll);
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  return (
    <header
      className={`fixed top-0 inset-x-0 z-50 transition-colors duration-500 ${
        scrolled
          ? "bg-[#0A0714]/85 backdrop-blur-md border-b border-[#D4A85B]/15"
          : "bg-transparent"
      }`}
    >
      <div className="max-w-7xl mx-auto px-6 md:px-10 h-20 flex items-center justify-between">
        <a href="#top" className="flex items-center gap-3 group">
          <div className="relative w-12 h-12 rounded-full overflow-hidden ring-1 ring-[#D4A85B]/50 bg-[#6b1fb0]">
            <img
              src={brand.logo}
              alt="Mindful Matters logo"
              className="w-full h-full object-cover"
            />
            <div className="absolute -inset-1 rounded-full border border-[#D4A85B]/25 animate-orbit-slow" />
          </div>
          <div className="leading-none">
            <div className="font-script text-[30px] text-[#EDE3D0] leading-none pt-1">{brand.name}</div>
            <div className="text-[9px] uppercase tracking-[0.24em] text-[#D4A85B]/85 whitespace-nowrap mt-1.5">
              {brand.submark}
            </div>
          </div>
        </a>

        <nav className="hidden md:flex items-center gap-8">
          {navLinks.map((l) => (
            <a
              key={l.href}
              href={l.href}
              className="text-[13px] uppercase tracking-[0.22em] text-[#EDE3D0]/85 hover:text-[#D4A85B] transition"
            >
              {l.label}
            </a>
          ))}
        </nav>

        <a
          href={brand.stanUrl}
          target="_blank"
          rel="noopener noreferrer"
          onClick={(e) => { e.preventDefault(); setIntakeOpen(true); }}
          className="hidden md:inline-flex items-center rounded-full border border-[#D4A85B]/70 text-[#D4A85B] px-5 py-2.5 text-xs uppercase tracking-[0.28em] hover:bg-[#D4A85B] hover:text-[#0A0714] transition cursor-pointer"
        >
          Book a session
        </a>

        <button className="md:hidden text-[#D4A85B]" onClick={() => setOpen((o) => !o)} aria-label="Menu">
          {open ? <X size={22} /> : <Menu size={22} />}
        </button>
      </div>

      {open && (
        <div className="md:hidden bg-[#0A0714] border-t border-[#D4A85B]/15">
          <div className="px-6 py-6 flex flex-col gap-4">
            {navLinks.map((l) => (
              <a
                key={l.href}
                href={l.href}
                onClick={() => setOpen(false)}
                className="text-[#EDE3D0]/85 text-sm uppercase tracking-[0.22em]"
              >
                {l.label}
              </a>
            ))}
              <a
                href={brand.stanUrl}
                target="_blank"
                rel="noopener noreferrer"
                onClick={(e) => { e.preventDefault(); setOpen(false); setIntakeOpen(true); }}
                className="mt-2 inline-flex items-center justify-center rounded-full border border-[#D4A85B] text-[#D4A85B] px-5 py-3 text-xs uppercase tracking-[0.28em]"
              >
                Book a session
              </a>
          </div>
        </div>
      )}

      <IntakeModal open={intakeOpen} onClose={() => setIntakeOpen(false)} />
    </header>
  );
};

export default Navbar;
